module.exports = __webpack_public_path__ + "static/media/sow-section-4-banner.ab2edc7d.svg";